import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDeviceGroupDocument } from './delete.generated';

export const useDeleteDeviceGroup = (
  options: ApiOptions<typeof DeleteDeviceGroupDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DeleteDeviceGroupDocument, {
    ...useNotifications(DeleteDeviceGroupDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteDeviceGroup?.deletedIds.length ?? 0;
        return t('api.device_groups.delete_success_plural', { count });
      },
    }),
    update(cache, { data }) {
      if (!data?.deleteDeviceGroup?.deletedIds.length) return;
      data.deleteDeviceGroup.deletedIds.forEach((id) =>
        cache.evict({ id: `DeviceGroupNew:${id}` }),
      );
    },
    ...options,
  });
};
